/*
 * @Author: Paco
 * @Date: 2018-11-23 20:39:54
 * @LastEditTIme: Paco
 * @Description:
 */

import Axios from 'axios';

import * as config from '@/config';
import uuid from '@wtdc/shortid';
import { getTraceId } from '@/business/spider/track';
import Sentry from '@/business/sentry';
import cookies from '@/utils/cookie';
import Utils from '@/utils/utils';

const { mockApi, BASE_API_ROOT, env_config } = config;

const axios = Axios.create({ withCredentials: true });

axios.defaults.baseURL = BASE_API_ROOT;
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';

/**
 * 添加ie缓存清理
 * @params config
 * @returns {*}
 */
const addUidForIe = function(config) {
  if(config.method === 'get') {
    if(config.params) {
      config.params.t = uuid();
    } else {
      config.params = {
        t: uuid()
      };
    }
  }
  return config;
};

/**
 * 添加headers参数
 * @param {*} config
 * @returns config
 */
const addCommonData = function(config) {
  if(!config.headers) config.headers = {};
  const { signature } = Utils.createEncryption();
  Object.assign(config.headers, {
    // ---- 在此添加公共的headers参数 ----
    'Gray-Status': env_config.ENV === 'PRO' ? 1 : 0, // 原小程序内控制是否过滤数据 filterStatus: 1过滤, 0不过滤
    traceId: getTraceId(), // traceId
    signature
  });

  // 二维码检查添加token
  const qr_check_token = window.sessionStorage.getItem('qr_check_token');
  if(qr_check_token) {
    Object.assign(config.headers, {
      token: qr_check_token
    });
  }

  return config;
};

const formatResponse = (response = {}) => {
  const data = response.data || {};
  if(data.errCode === 0) {
    return data.data;
  } else {
    const { data = {}, config = {}, request = {}} = response;
    // 业务错误 sentry埋点
    Sentry.captureMessage(`HTTP ERROR: ${data.message}`, {
      extra: {
        ...formatExtra(request),
        data: config.data || {}
      }
    });
    const throwErrorCode = throwErrorCodeUrl.some(item => {
      if(request.responseURL.includes(item)) {
        return true;
      }
    });
    if(throwErrorCode) {
      throw data;
    } else {
      throw new Error(`CAPTURED: ${data.message}`);
    }
  }
};

function formatExtra(res = {}) {
  const { response, responseText, responseType, responseURL, responseXML, status, statusText } = res;
  return {
    response,
    responseText,
    responseType,
    responseURL,
    responseXML,
    status,
    statusText,
    cookie: cookies.get()
  };
}

const formatAjaxError = (error = {}) => {
  const errorRes = error.response || {};
  const { request = {}, config = {}, data = '' } = errorRes;
  // 服务器错误 sentry埋点
  Sentry.captureMessage(`HTTP ERROR: ${data}`, {
    extra: {
      ...formatExtra(request),
      data: config.data || {}
    }
  });
  throw new Error(`CAPTURED: ${data}`);
};

axios.interceptors.request.use(addUidForIe);

axios.interceptors.request.use(addCommonData);

//Add a response interceptor
axios.interceptors.response.use(formatResponse, formatAjaxError);

export default function axiosServices(root) {
  return (method, route) => data => {
    const params = method === 'get' ? { params: data } : data;
    return axios[method](
      `${root}/v1.0/${route}`,
      params
    );
  };
}

export function withoutVersionService(root) {
  return (method, route) => data => {
    const params = method === 'get' ? { params: data } : data;
    return axios[method](
      `${root}/${route}`,
      params
    );
  };
}

export function axiosServices4Crm(root) {
  return (method, route) => (data) => {
    const payload = method === 'get' ? { params: data } : data;
    return axios[method](
      `scrm/v1.0/${root}/${route}`,
      payload
    );
  };
}

export function withMockService(root, id) {
  return (method, route) => data => {
    const params = method === 'get' ? { params: data } : data;
    return axios[method](
      `${mockApi}${id}/${root}/${route}`,
      params
    );
  };
}

// 抛出errorCode的url
const throwErrorCodeUrl = [
  'channelcenter/v1.0/nftSceneCheckRecord/insert'
];
